import { zustandImmerMiddleware } from '@sketchnote/shared-components';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { createBoardSlice, createColumnSlice, createCommentSlice, createItemSlice } from './slices';
import { KanbanState } from './types';

export const useKanbanStore = create<
  KanbanState,
  [['zustand/devtools', KanbanState], ['zustand/immer', KanbanState]]
>(
  devtools(
    zustandImmerMiddleware((set, get) => ({
      setIsReadOnly: (value) =>
        set((state) => {
          state.isReadOnly = value;
        }),

      type: 'boards',
      setType: (value) =>
        set((state) => {
          state.type = value;
        }),
      isLoading: false,
      labels: [],
      setLabels: (value) =>
        set((state) => {
          state.labels = value;
        }),

      selectables: {},
      setSelectables: (fieldId, value) =>
        set((state) => {
          state.setSelectables[fieldId] = value;
        }),

      currentUser: {
        email: '',
        id: '',
        avatar: '',
        firstname: '',
        lastname: '',
      },
      setCurrentUser: (value) =>
        set((state) => {
          state.currentUser = value;
        }),

      ...createItemSlice(set, get),
      ...createCommentSlice(set, get),
      ...createColumnSlice(set, get),
      ...createBoardSlice(set, get),

      members: [],
      setMembers: (value) =>
        set((state) => {
          state.members = value;
        }),

      onSearchUsers: async () => [],
      setOnSearchUsers: (func) =>
        set((state) => {
          state.onSearchUsers = func;
        }),

      apiCallbacks: {},
      setApiCallbacks: (values: KanbanState['apiCallbacks']) =>
        set((state) => ({ ...state, apiCallbacks: { ...state.apiCallbacks, ...values } })),
    }))
  )
);
